import { useContext } from "react";

import { ApiErrorsContext } from "../contexts";

export function useApiErrors() {
  return useContext(ApiErrorsContext);
}
